import { render, staticRenderFns } from "./CActivity.vue?vue&type=template&id=616d57fa&scoped=true&"
import script from "./CActivity.vue?vue&type=script&lang=js&"
export * from "./CActivity.vue?vue&type=script&lang=js&"
import style0 from "./CActivity.vue?vue&type=style&index=0&id=616d57fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d57fa",
  null
  
)

export default component.exports